import { render } from "./Gameinside.vue?vue&type=template&id=f22c5888&scoped=true"
import script from "./Gameinside.vue?vue&type=script&lang=js"
export * from "./Gameinside.vue?vue&type=script&lang=js"

import "./Gameinside.vue?vue&type=style&index=0&id=f22c5888&lang=less&scoped=true"

import exportComponent from "D:\\work\\hw-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f22c5888"]])

export default __exports__